import React from 'react';

import { RepositoryPrivilege } from 'src/sections/repository/types';

import CreateBranch, { Props } from '../components/create-branch-dialog';
import { CREATE_FROM } from '../constants';

import connect from './connect';

export default connect((props: Props) => (
  <CreateBranch {...props} createFrom={CREATE_FROM.REPO_DIALOG} />
)) as unknown as React.ComponentType<
  React.PropsWithChildren<{
    requiredLevel: RepositoryPrivilege;
    shouldRenderCreateBranchButton: boolean;
    source: string;
  }>
>;
